import buttonsTemplates from './buttonsTemplates';

import {
  DefaultButton,
  SecondaryButton,
  ExceptionCancelButton,
} from './buttonsLayouts';

const buttonsSet = [
  {
    type: 'primary',
    previews: [
      {
        component: DefaultButton,
        codeTemplate: buttonsTemplates.primary,
        optionsGroup: [
          {
            label: 'Large',
            options: [
              { label: 'only text', type: 'radio', options: {icon:''} },
              { label: 'with icon left', type: 'radio', options: {icon: 'star', right: false} },
              { label: 'with icon right', type: 'radio', options: {icon: 'star', right: true} },
            ]
          },
          {
            label: 'Colour',
            options: [
              { label: 'red', type: 'radio', options: {classes: '', bgColor: null} },
              { label: 'black', type: 'radio', options: {classes: 'black', bgColor: null} },
              { label: 'white', type: 'radio', options: {classes: 'white', bgColor: 'black'} },
            ]
          },
        ],
      },
      {
        component: DefaultButton,
        codeTemplate: buttonsTemplates.primarySmall,
        optionsGroup: [
          {
            label: 'Small',
            options: [
              { label: 'red', type: 'radio', options: {classes: 'small', bgColor: null} },
              { label: 'black', type: 'radio', options: {classes: 'small black', bgColor: null} },
              { label: 'white', type: 'radio', options: {classes: 'small white',  bgColor: 'black'} },
            ]
          },
        ],
      }
    ]
  },
  {
    type: 'secondary',
    previews: [
      {
        name: 'large',
        component: SecondaryButton,
        codeTemplate: buttonsTemplates.secondary,
        optionsGroup: [
          {
            label: 'Large',
            options: [
              { label: 'only text', type: 'radio', options: {icon:''} },
              { label: 'with icon left', type: 'radio', options: {icon: 'star', right: false} },
              { label: 'with icon right', type: 'radio', options: {icon: 'star', right: true} },
            ]
          },
          {
            label: 'Colour',
            options: [
              { label: 'red', type: 'radio', options: {bgColor: null, classes: ''} },
              { label: 'black', type: 'radio', options: {classes: 'black', bgColor: null} },
              { label: 'white', type: 'radio', options: {classes: 'white ', bgColor: 'black'} }
            ]
          },
        ],
      },
      {
        component: SecondaryButton,
        codeTemplate: buttonsTemplates.secondarySmall,
        optionsGroup: [
          {
            label: 'Small',
            options: [
              { label: 'red', type: 'radio', options: {classes: 'secondary small', bgColor: null} },
              { label: 'black', type: 'radio', options: {classes: 'secondary small black', bgColor: null} },
              { label: 'white', type: 'radio', options: {classes: 'secondary small white', bgColor: 'black'} }
            ]
          },
        ],
      }
    ]
  },
  {
    type: 'exceptions',
    previews: [
      {
        component: ExceptionCancelButton,
        codeTemplate: buttonsTemplates.exceptionCancel,
        optionsGroup: [
          {
            label: 'Cancel',
            options: [
              { label: 'default', type: 'radio', options: {classes:'special',  bgColor: 'black'} },
            ]
          },
        ],
      },
      {
        component: DefaultButton,
        codeTemplate: buttonsTemplates.exceptionNext,
        optionsGroup: [
          {
            label: 'Next',
            options: [
              { label: 'red', type: 'radio', options: {bgColor: null, classes: 'special next', __layout: 'default'} },
              { label: 'white', type: 'radio', options: {classes: 'special next white', bgColor: 'black'} }
            ]
          },
        ],
      }
    ]
  },
];

export default buttonsSet;



// WEBPACK FOOTER //
// ./src/containers/elements/Buttons/constants/buttonsSet.js